/** Empty-state preview of a sample analysis conversation. */
import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Text } from '@/components/ui/text';
import { useResponsive } from '../../../hooks/useResponsive';
import { useTranslation } from '../../../hooks/useTranslation';
import { COLORS } from '../chatConstants';

export function SampleChatPreview({ onOpen }: { onOpen: () => void }) {
  const { t } = useTranslation();
  const { isPhone } = useResponsive();

  return (
    <View nativeID="chat_sample_analysis" testID="chat_sample_analysis" style={{ width: '100%', maxWidth: 620 }}>
      <TouchableOpacity
        onPress={onOpen}
        accessibilityRole="button"
        accessibilityLabel={t('chat.samplePreviewOpen')}
        style={{
          width: '100%',
          borderRadius: 18,
          borderWidth: 1,
          borderColor: '#BFDBFE',
          backgroundColor: '#FFFFFF',
          padding: isPhone ? 16 : 20,
          gap: 13,
        }}
      >
      {/* Wraps on phones: the long badge used to push the title and icon
          past the card's right edge at 390px. */}
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
        <View
          style={{
            flexShrink: 1,
            maxWidth: '100%',
            borderRadius: 999,
            backgroundColor: '#DBEAFE',
            paddingHorizontal: 10,
            paddingVertical: 5,
          }}
        >
          <Text selectable style={{ color: COLORS.primary, fontSize: 11, fontWeight: '900' }}>
            {t('chat.samplePreviewBadge')}
          </Text>
        </View>
        <Text selectable style={{ flexGrow: 1, flexShrink: 1, minWidth: 140, color: COLORS.text.primary, fontSize: 16, fontWeight: '900' }}>
          {t('chat.samplePreviewTitle')}
        </Text>
        <MaterialIcons name="open-in-new" size={19} color={COLORS.primary} />
      </View>
      <Text selectable style={{ color: COLORS.text.secondary, fontSize: 13, lineHeight: 20 }}>
        {t('chat.samplePreviewSummary')}
      </Text>
      <View style={{ gap: 8 }}>
        <View style={{ alignSelf: 'flex-end', maxWidth: '88%', borderRadius: 13, backgroundColor: '#EFF6FF', padding: 10 }}>
          <Text selectable style={{ color: COLORS.text.primary, fontSize: 12, lineHeight: 18 }}>
            {t('chat.samplePreviewQuestionOne')}
          </Text>
        </View>
        <View style={{ alignSelf: 'flex-start', maxWidth: '92%', borderRadius: 13, backgroundColor: COLORS.surface, padding: 10 }}>
          <Text selectable style={{ color: COLORS.text.secondary, fontSize: 12, lineHeight: 18 }}>
            {t('chat.samplePreviewAnswerOne')}
          </Text>
        </View>
      </View>
      <Text selectable style={{ color: COLORS.primary, fontSize: 13, fontWeight: '800' }}>
        {t('chat.samplePreviewOpen')}
      </Text>
      </TouchableOpacity>
    </View>
  );
}
